<template>
    <div>
        <scenario-templates 
                v-once
                v-if="showScenarioTemplates"

                v-bind:scenarioIds="scenarioIds"
                @trigger-change-info="currentComponent = changeInfoComponent"
        >
        </scenario-templates>
        
        <change-info
            v-once
            v-if="showChangeInfo"
            
            @cancel-change-info="currentComponent = scenarioTemplatesComponent"
        >
        </change-info>
    </div>
</template>

<script>
    import ScenarioTemplates from "./Templates/ScenarioTemplates.vue";
    import ChangeInfo from "./ChangeInfo/Info.vue";
    
    export default {
        name: "templates",
        components: {
            ChangeInfo,
            ScenarioTemplates
        },
        created(){
            this.currentComponent = this.scenarioTemplatesComponent;
        },
        computed: {
            showChangeInfo(){
                return this.currentComponent === this.changeInfoComponent;
            },
            showScenarioTemplates(){
                return this.currentComponent === this.scenarioTemplatesComponent;
            }
        },
        data: () => ({
            currentComponent: '',
            
            changeInfoComponent: 'changeInfo',
            scenarioTemplatesComponent: 'scenarioTemplates'
        }),
        props: {
            scenarioIds: {
                type: Array,
                required: true
            }
        }
    };
</script>

<style scoped>

</style>
